###
Uses DataRangePicker on element

  @param config - Configuration for date picker
  @param callback - Call this method on datepicker clear and hide events
  @param start - Start time in seconds or miliseconds
  @param end - End time in seconds or miliseconds
###
angular
	.module 'App.Directive'
	.directive 'dateRangePicker', ->
		scope:
			userConfig: '=?config'
			start: '=?'
			end: '=?'
			callback: '&?'
		require:
			formCtrl: '?^^form'
		restrict: 'A'
		# @TODO: Refactor if upgrading Angular version. "replace" is deprecated and will be removed in v2+ of Angular
		replace: true
		template: '<input type="text" readonly ng-model="dateRangePicker.displayValue">'
		controller: 'DateRangePickerController'
		controllerAs: 'dateRangePicker'
		bindToController: true

class DateRangePickerController extends AbstractController
	@register angular.module 'App.Directive'
	@inject '$scope',
		'$element'
		'$attrs'
		'$translate'
		'$timeout'
		'DateService'

	initialize: ->
		@required ?= false
		@disabled ?= false

		@$translate [
			'general.clear'
			'general.custom.range'
			'wbo.sunday'
			'wbo.monday'
			'wbo.tuesday'
			'wbo.wednesday'
			'wbo.thursday'
			'wbo.friday'
			'wbo.saturday'
			'wbo.january'
			'wbo.february'
			'wbo.march'
			'wbo.april'
			'wbo.may'
			'wbo.june'
			'wbo.july'
			'wbo.august'
			'wbo.september'
			'wbo.october'
			'wbo.november'
			'wbo.december'
			'wbo.today'
			'wbo.yesterday'
			'wbo.this.week'
			'wbo.this.month'
		]
		.then (translations) =>
			# When using $translateProvider.useSanitizeValueStrategy('sce') translation becomes object instead of string
			angular.forEach translations, (translation, key) ->
				if typeof translation == 'object'
					translations[key] = translation.toString()

			@initConfig(translations)

			@setDates()

			@$scope.$watch 'dateRangePicker.start', (newVal, oldVal) => @onUpdate() if newVal != oldVal
			@$scope.$watch 'dateRangePicker.end', (newVal, oldVal) => @onUpdate() if newVal != oldVal

			@$element
				.daterangepicker @config

				.on 'cancel.daterangepicker', (event, picker) =>
					return if not @config.enableClear

					@start = null
					@end = null

					@config.startDate = moment()
					@config.endDate = moment()
					picker.setStartDate(moment())
					picker.setEndDate(moment())
					@showValue(null, null)
					@updateFormStatus()
					@callCallback(null, null)

				.on 'apply.daterangepicker', (event, picker) =>
					@$scope.$apply =>
						@start = picker.startDate.unix()
						@end = picker.endDate.unix()

						@showValue(picker.startDate, picker.endDate)
						@updateFormStatus()
						@callCallback(picker.startDate, picker.endDate)

					picker.updateView()

				.on 'show.daterangepicker', (event, picker) =>
					return if !@config.timePickerOnly
					@config.timePicker = true
					picker.container.find('.calendar-table').hide();
					picker.container.find('.ranges').hide();
					picker.container.find('.drp-selected').hide();
					picker.container.find('.drp-calendar.left').css('border-left', 'none');

	initConfig: (translations) ->
		@userConfig ?= {}
		# @link http://www.daterangepicker.com/#options
		defaultConfig =
			showDropdowns: true
			applyButtonClasses: 'button green'
			cancelButtonClasses: 'button red'
			singleDatePicker: false
			alwaysShowCalendars: true
			timePicker: false
			timePickerOnly: false
			timePicker24Hour: true
			timePickerIncrement: 5
			opens: 'left'
			drops: 'auto'
			showISOWeekNumbers: true
			enableClear: false

		@config = angular.extend({}, defaultConfig, @userConfig)

		@config.autoApply = not @config.enableClear
		@config.autoUpdateInput = false

		@initLocale(translations)
		@initRanges(translations)

	initRanges: (translations) ->
		if not @config.singleDatePicker
			@config.ranges =
				"#{translations['wbo.today']}": [moment().startOf('day'), moment().endOf('day')]
				"#{translations['wbo.yesterday']}": [moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days')]
				"#{translations['wbo.this.week']}": [moment().startOf('week'), moment().endOf('week')]
				"#{translations['wbo.this.month']}": [moment().startOf('month'), moment().endOf('month')]

	initLocale: (translations) ->
		locale =
			customRangeLabel: translations['general.custom.range']
			cancelLabel: if @config.enableClear then translations['general.clear'] else translations['general.cancel']
			firstDay: 1
			separator: ' / '
			format: @DateService.getFormat(@config.timePicker)
			daysOfWeek: [
				translations['wbo.sunday'].substring(0,3).toUpperCase()
				translations['wbo.monday'].substring(0,3).toUpperCase()
				translations['wbo.tuesday'].substring(0,3).toUpperCase()
				translations['wbo.wednesday'].substring(0,3).toUpperCase()
				translations['wbo.thursday'].substring(0,3).toUpperCase()
				translations['wbo.friday'].substring(0,3).toUpperCase()
				translations['wbo.saturday'].substring(0,3).toUpperCase()
			]
			monthNames: [
				translations['wbo.january']
				translations['wbo.february']
				translations['wbo.march']
				translations['wbo.april']
				translations['wbo.may']
				translations['wbo.june']
				translations['wbo.july']
				translations['wbo.august']
				translations['wbo.september']
				translations['wbo.october']
				translations['wbo.november']
				translations['wbo.december']
			]
		@config.locale = angular.extend({}, locale, if @config.locale? then @config.locale else {})

	onUpdate: ->
		@setDates()

		picker = @$element.data('daterangepicker')

		# Not initialized yet
		return if not picker?

		picker.setStartDate @config.startDate
		picker.setEndDate @config.endDate if not @config.singleDatePicker
		picker.updateView()
		@updateFormStatus()

	showValue: (startDate, endDate) ->
		@displayValue = null
		format = @config.locale.format

		if !_.isEmpty @config.format
			format = @config.format

		if @config.singleDatePicker
			@displayValue = startDate.format(format) if startDate?

		else if startDate? and endDate?
			@displayValue = startDate.format(format) + @config.locale.separator + endDate.format(format)

		@$element.val(@displayValue)

	setDates: ->
		@config.startDate = @getMomentObject(@start)
		@config.endDate = @getMomentObject(@end) if not @config.singleDatePicker

		@showValue(@config.startDate, @config.endDate)

	getMomentObject: (timestamp) ->
		return undefined if not timestamp?

		if ('' + timestamp).length == 10
			return moment.unix(timestamp)
		else
			return moment(timestamp)

	updateFormStatus: ->
		@formCtrl.$setDirty() if @formCtrl?

	callCallback: (startDate, endDate) ->
		return if not @callback?

		@$timeout.cancel(@callbackTimer)
		@callbackTimer = @$timeout(
			=>
				@callback({
					startDate: startDate,
					startDateUnix: if startDate? then startDate.unix() else null,
					endDate: endDate,
					endDateUnix: if endDate? then endDate.unix() else null
				})
			,
			10
		)
